import React, { FC, ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { FormControl, InputAdornment, OutlinedInput } from '@mui/material';
import { makeStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import classes from './UserProfile.module.scss';
import { useStatus, useUsers } from '../../hooks/entityHooks';
import { PreLoader } from '../../Components/PreLoader';
import { UserProfileCard } from '../../Components/UserProfileCard';
import 'moment/locale/ru';
import { UserProfileTable } from '../../Components/UserProfileTable';
import { ChangeUserPassword } from '../../Components/Dialogs/ChangeUserPassword';
import { User } from '../../types/user';
import { ILoginData } from '../../types/loginData';

type Params = {
  id: string;
};

export const UserProfile: FC = (): ReactElement => {
  const { getEntity: getUserInfo, entity: userInfo, initLoading } = useUsers();
  const params = useParams<Params>();
  const currentUserId = +params.id;
  const [loginData, setLoginData] = useState<ILoginData | null>(null);

  const [open, setOpen] = useState(false);
  const { getLoginData } = useStatus();

  const useStyles = makeStyles({
    root: {
      width: '100%',
      fontFamily: 'HelveticaNeueCyr',
      background: '#FFFFFF',
      '&::placeholder': {
        color: '#CACED2',
      },
      '&.Mui-focused': {
        border: '1px solid #FF7221',
        color: '#FF7221',
      },
      '&.MuiOutlinedInput': {
        borderColor: '#FF7221',
      },
    },
    emptyInput: {
      maxHeight: 44,
      borderColor: '#CACED2',
      '&.Mui-focused': {
        borderColor: '#FF7221',
      },
    },
    input: {
      maxHeight: 44,
      borderColor: '#EB564F',
      '&.Mui-focused': {
        borderColor: '#FF7221',
      },
    },
  });

  useEffect(() => {
    getUserInfo(currentUserId);
  }, [currentUserId]);

  const style = useStyles();

  const checkAccessUser = (user: User): boolean => {
    let myRoleType;
    let myId;
    const myProfile = localStorage.getItem('profile');
    if (myProfile) {
      myRoleType = JSON.parse(myProfile).data.user.roleType;
      myId = JSON.parse(myProfile).data.user.id;
    }
    switch (myRoleType) {
      case 1:
        if (myId === user.id) {
          return true;
        }
        if (myId !== user.id) {
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  };

  const checkDisplayButton = (user: User): boolean => {
    let myRoleType;
    let myId;
    const myProfile = localStorage.getItem('profile');
    if (myProfile) {
      myRoleType = JSON.parse(myProfile).data.user.roleType;
      myId = JSON.parse(myProfile).data.user.id;
    }
    switch (myRoleType) {
      case 1:
        return true;
      default:
        if (myId !== user.id) {
          return false;
        }
        return true;
    }
  };

  useEffect(() => {
    getLoginData(currentUserId).then((res) => setLoginData(res));
  }, []);

  return (
    <>
      {initLoading ? (
        <PreLoader />
      ) : (
        <section className={classes.userInfo}>
          <div className={classes.container}>
            <div className={classes.userInfo__search}>
              <FormControl className={style.root}>
                <OutlinedInput
                  placeholder="Введите ФИО сотрудника"
                  startAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>
            <UserProfileCard userInfo={userInfo} />
            <div className={classes.userInfo__password}>
              <div className={classes.password__wrap}>
                <div className={classes.password}>
                  <div className={classes.password__image} />
                  <div className={classes.password__text}>
                    <div className={classes.title}>Пароль</div>
                    <div className={classes.content}>
                      <FiberManualRecordIcon color="disabled" />
                      <FiberManualRecordIcon color="disabled" />
                      <FiberManualRecordIcon color="disabled" />
                      <FiberManualRecordIcon color="disabled" />
                      <FiberManualRecordIcon color="disabled" />
                      <FiberManualRecordIcon color="disabled" />
                    </div>
                  </div>
                </div>
                {userInfo && checkDisplayButton(userInfo) && (
                  <div className={classes.change_password}>
                    <button onClick={() => setOpen(true)}>
                      Изменить пароль
                    </button>
                  </div>
                )}
              </div>
            </div>
            {initLoading ? (
              <PreLoader />
            ) : (
              loginData && <UserProfileTable loginData={loginData} />
            )}
            {userInfo && checkDisplayButton(userInfo) && (
              <ChangeUserPassword
                isFullModal={checkAccessUser(userInfo)}
                open={open}
                setOpen={setOpen}
                userInfo={userInfo}
              />
            )}
          </div>
        </section>
      )}
    </>
  );
};
